export default "__VITE_ASSET__ClCPzZYE__"